import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.27344 12.2167L10.9805 20.9238L12.3948 19.5096L6.10186 13.2167L22.6877 13.2167L22.6877 11.2167L6.10187 11.2167L12.3948 4.92383L10.9805 3.50961L2.27344 12.2167Z",
		fill: "#395566"
	})
});
export default SvgLine;
